// Central content for the portfolio — easy to edit later.

const DRIVE_IMG = (id, sz = "w1600") =>
  `https://drive.google.com/thumbnail?id=${id}&sz=${sz}`;

// User photos from the shared Drive folder (16 total)
const USER_IMAGE_IDS = [
  "1AR-XRlNwx2fMr9_LmUIYu6wQTjZLMFOV",
  "1JiBmwHdrJs1Wzxuv8mNFGpAIhXxXRQYo",
  "126Hr3JSXcEMhrYWmwVjK3sNAq3X-kYw7",
  "1BXv5lPCPdX5lZN7i2WGNZXpBw5xx89EW",
  "1Z_Z-YnitMzxUTMJ8EfgqSqzMoeEoBxr0",
  "1hbKCsuHtoxeiBuifGfZosl2bkgnOJ_Zg",
  "1xM78a-lYvtlqdLjrn0k3tnxqnEzBygc0",
  "1ZnwEU6e5S1aXR1XOBkcYVJllv8LakeJR",
  "147b3N9vqV54pZRKkmTCIIYNHxclOrNKq",
  "1n6ieQ6b31F3s3nqcvJzP-acXl6DFbPKP",
  "1C81HIUuaGqC2hNJ9dHRbPRJQVnQJXkdu",
  "1cE5WEsnIwez2bFXfKyWXpcdYQv4mWuF_",
  "1lcItdkRAv2UuFdRkxFfw1MGL9Xc4UP8Z",
  "1Gw1nvsLUOpXstG5XsVOP7THTSxOgpIIF",
  "1dJuPPpNrSx6tbjrSm5PWBJDa_kDsqxG_",
  "1MqcCfNF7gE6CvcoxMK183A5Puy2r0PDU",
];

export const IMAGES = {
  heroBg: DRIVE_IMG(USER_IMAGE_IDS[0], "w2000"),
  about: DRIVE_IMG(USER_IMAGE_IDS[1]),
  equipment: DRIVE_IMG(USER_IMAGE_IDS[2]),
};

// Remaining images for the Behind-the-Scenes gallery bento
export const GALLERY_SHOTS = USER_IMAGE_IDS.slice(3).map((id) => DRIVE_IMG(id));

export const HERO = {
  overline: "Creative Producer — Motion — Film — AI",
  lines: ["Stories", "That Stay."],
  paragraph:
    "Every frame has a purpose. Every cut shapes emotion. Every project is crafted to create an experience — not just another video.",
  sub:
    "I'm Swaraj Sawant, a Creative Producer specializing in filmmaking, motion design, video editing, and AI-powered visual storytelling. From the first idea to the final frame, I create content that captures attention, builds connections, and leaves a lasting impression.",
  tag: "Great stories don't just get watched. They get remembered.",
};

export const MARQUEE_ITEMS = [
  "Filmmaking",
  "Motion Graphics",
  "Creative Direction",
  "Branded Content",
  "AI Visual Storytelling",
  "Commercials",
  "Video Editing",
  "Post-Production",
];

export const ABOUT = {
  overline: "About",
  title: "Creativity With Intention.",
  intro:
    "The best visuals don't happen by accident. They begin with an idea, grow through collaboration, and come alive through thoughtful execution.",
  chapters: [
    {
      no: "01",
      title: "Nine Years, One Craft",
      body:
        "For over nine years, I've been creating motion graphics, films, commercials, and digital content that balance storytelling with strategy.",
    },
    {
      no: "02",
      title: "Every Project, A Challenge",
      body:
        "Each project is an opportunity to solve a creative challenge — shaping a brand's identity, launching a campaign, or turning a simple concept into something memorable.",
    },
    {
      no: "03",
      title: "From Concept To Final Frame",
      body:
        "From concept development and scripting to production, editing, and post-production, every detail matters. Because the strongest stories aren't just seen — they're felt.",
    },
  ],
};

// Category groups used by the Portfolio filter tabs
export const PORTFOLIO_GROUPS = [
  "All",
  "Short Films",
  "Creative Production",
  "Broadcast Motion Graphics",
];

// Layout patterns cycled for the Broadcast Motion Graphics group
const BMG_LAYOUT = [
  ["lg:col-span-6", "aspect-[3/2]"],
  ["lg:col-span-6", "aspect-[3/2]"],
  ["lg:col-span-4", "aspect-[4/5]"],
  ["lg:col-span-4", "aspect-[4/5]"],
  ["lg:col-span-4", "aspect-[4/5]"],
  ["lg:col-span-8", "aspect-[16/10]"],
  ["lg:col-span-4", "aspect-[4/5]"],
];

const BMG_ITEMS = [
  { id: "pagalpanti-bumper",   title: "Pagalpanti Show Bumper",             image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/ac374d219568991.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png", link: "https://www.behance.net/gallery/219568991/Pagalpanti-Show-Bumper" },
  { id: "sce-promo",           title: "SCE Show Graphical Promo",           image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/7fbd0f219455167.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png", link: "https://www.behance.net/gallery/219455167/SCE-show-graphical-promo" },
  { id: "yom-teaser",          title: "Yom — Animated Promo / Teaser",      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/0dc07e219454997.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png", link: "https://www.behance.net/gallery/219454997/Yom-Animated-show-PromoTeaser" },
  { id: "sustance-gfx",        title: "Sustance — GFX Promo",               image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/c75d3a219454503.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png", link: "https://www.behance.net/gallery/219454503/Show-Sustance-GFX-Promo" },
  { id: "new-year-promo",      title: "New Year Promo GFX",                 image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/15547c219454357.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png", link: "https://www.behance.net/gallery/219454357/New-Year-Promo-GFX" },
  { id: "baalveer-2-dtg",      title: "Baalveer 2 — DTG GFX",               image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/9e0300219454227.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png", link: "https://www.behance.net/gallery/219454227/Baalveer-2-DTG-GFX" },
  { id: "holi-wishplate",      title: "Holi Wishplate — Q TV",              image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/67fb4b219287723.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png", link: "https://www.behance.net/gallery/219287723/Holi-WIshplate-for-Q-TV" },
  { id: "aston-lowerthirds",   title: "Aston / Lower Thirds",               image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/4d4d61219203807.Y3JvcCw4MDgsNjMyLDAsMA.png",    link: "https://www.behance.net/gallery/219203807/Aston-Lowerthirds" },
  { id: "channel-bugs",        title: "Bugs for Channel",                    image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/404b23219211889.Y3JvcCw4MDgsNjMyLDAsMA.png",    link: "https://www.behance.net/gallery/219211889/Bugs-for-Channel" },
  { id: "shudh-desi-tadka",    title: "Shudh Desi Tadka — QTV",             image: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/d67503185522249.656594d0c68b3.png",       link: "https://www.behance.net/gallery/185522249/Shudh-Desi-Tadka-Show-by-QTV" },
  { id: "viral-vani",          title: "Viral Vani Ki Bhavishyavani",        image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/eea0db185522153.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png", link: "https://www.behance.net/gallery/185522153/Viral-Vani-ki-Bhavishyavani-AI-host-show-by-QTV" },
  { id: "kali-show-pkg",       title: "Kali — Show PKG",                    image: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/f99874170652035.646215314a293.png",       link: "https://www.behance.net/gallery/170652035/KALI-SHOW-PKG-Q-YOU-MEDIA" },
  { id: "gundi-ki-gundigiri",  title: "Gundi Ki Gundigiri — Show Title",    image: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/07084a164278651.63f46a172b4ff.png",       link: "https://www.behance.net/gallery/164278651/Show-Title-Gundi-Ki-Gundigiri" },
  { id: "sweety-ki-toli",      title: "Sweety Ki Toli — Logo",              image: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/c8da9f162714981.63da30a644a71.png",       link: "https://www.behance.net/gallery/162714981/Sweety-Ki-Toli-Logo-Design" },
  { id: "mr-mrs-llb",          title: "Mr & Mrs LLB — Poster",              image: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/921b23162714773.63da300b11313.png",       link: "https://www.behance.net/gallery/162714773/MR-Mrs-LLB-Poster" },
  { id: "q-marathi-bumper",    title: "Show Title Bumper — Q Marathi",      image: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/70f81d144441637.628cb3afd3b53.jpg",       link: "https://www.behance.net/gallery/144441637/Show-Title-Bumper-for-Q-Marathi" },
  { id: "jurm-ka-chehra",      title: "Jurm Ka Chehra — Graphical Promo",   image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/8b7b74144441487.Y3JvcCwxMzgwLDEwODAsMCww.png",   link: "https://www.behance.net/gallery/144441487/Jurm-Ka-Chehra-Coming-Soon-Graphical-Promo" },
  { id: "qtv-astons",          title: "Show Astons / Lower Thirds — Q TV",  image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/645dcc144438607.Y3JvcCw4MDgsNjMyLDAsMA.png",    link: "https://www.behance.net/gallery/144438607/Shows-Astons-Lower-Thirds-for-Q-TV" },
  { id: "dilchasp-kahaniya",   title: "Dilchasp Kahaniya — Show Bumper",    image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/f78a98144437515.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png", link: "https://www.behance.net/gallery/144437515/Dilchasp-Kahaniya-Show-Bumper-for-Q-TV" },
  { id: "dhakad-kudies",       title: "Dhakad Kudies Dhamaka — Show Bumper",image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/bc560b144437143.Y3JvcCw4MjMsNjQ0LDU0OCwzMjY.png", link: "https://www.behance.net/gallery/144437143/Dhakad-Kudies-Dhamaka-Show-Bumper-for-Q-TV" },
  { id: "aashram-poster",      title: "Aashram — Motion Poster",            image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/7148e1144435309.Y3JvcCw4ODcsNjk0LDE4NCw4Mw.png",  link: "https://www.behance.net/gallery/144435309/Aashram-Motion-Poster-For-Q-TV" },
];

const BMG_PROJECTS = BMG_ITEMS.map((p, i) => {
  const [span, ratio] = BMG_LAYOUT[i % BMG_LAYOUT.length];
  return { ...p, category: "Broadcast Motion Graphics", group: "Broadcast Motion Graphics", year: "", span, ratio };
});

export const PORTFOLIO = {
  overline: "Selected Work",
  title: "Every Frame Tells A Story.",
  intro:
    "A collection of ideas brought to life through motion, design, filmmaking, and creativity. From brand films and commercials to motion graphics and AI-generated content — every piece is crafted with purpose.",
  projects: [
    // ---- Short Films ----
    {
      id: "a-aai",
      title: "A Aai",
      category: "Award-Winning Short Film",
      group: "Short Films",
      year: "",
      image: "https://drive.google.com/thumbnail?id=1tYnzKe5X5PGYg0tlu3GivpG3mZcPrusH&sz=w1600",
      video: "https://drive.google.com/file/d/1tYnzKe5X5PGYg0tlu3GivpG3mZcPrusH/preview",
      award: true,
      span: "lg:col-span-8",
      ratio: "aspect-[16/10]",
    },
    {
      id: "olakh",
      title: "Olakh",
      category: "Short Film",
      group: "Short Films",
      year: "",
      image: "https://drive.google.com/thumbnail?id=1QYY9ArNOQF9jkml2naKjz973pjoWwktS&sz=w1600",
      video: "https://drive.google.com/file/d/1QYY9ArNOQF9jkml2naKjz973pjoWwktS/preview",
      span: "lg:col-span-4",
      ratio: "aspect-[4/5]",
    },

    // ---- Creative Production ----
    {
      id: "japandi-living",
      title: "Japandi Living",
      category: "AI Cinematic Animation",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/70a5f1250730817.Y3JvcCw5ODEsNzY4LDE3OSww.png",
      link: "https://www.behance.net/gallery/250730817/JAPANDI-LIVING-AI-Powered-Cinematic-Animation",
      span: "lg:col-span-4",
      ratio: "aspect-[4/5]",
    },
    {
      id: "timeless-casa",
      title: "Timeless Casa",
      category: "AI Video",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/8c940a250732243.Y3JvcCw5ODEsNzY4LDE3OSww.png",
      link: "https://www.behance.net/gallery/250732243/TIMELESS-CASA-A-Home-Beyond-Trends-AI-Video",
      span: "lg:col-span-8",
      ratio: "aspect-[16/10]",
    },
    {
      id: "project-phoenix",
      title: "Project Phoenix",
      category: "Culture Film",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/f22d43250738333.Y3JvcCwxMDgwLDg0NCwwLDExNw.png",
      link: "https://www.behance.net/gallery/250738333/Project-Phoenix-Internal-Motivation-Culture-Video",
      span: "lg:col-span-6",
      ratio: "aspect-[3/2]",
    },
    {
      id: "bonito-designs",
      title: "Bonito Designs",
      category: "Performance Marketing",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/49dbb6250732703.Y3JvcCw0NTAwLDM1MTksMCw0OTA.jpg",
      link: "https://www.behance.net/gallery/250732703/Performance-Marketing-Creatives-for-Bonito-Designs",
      span: "lg:col-span-6",
      ratio: "aspect-[3/2]",
    },
    {
      id: "mop-up-success",
      title: "Mop-Up & Success",
      category: "Marketing Creatives",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/6f65f8250736933.Y3JvcCwxMDgwLDg0NCwwLDMyOA.png",
      link: "https://www.behance.net/gallery/250736933/Mop-Up-Success-Creatives",
      span: "lg:col-span-12",
      ratio: "aspect-[16/7]",
    },
    {
      id: "lucky-draw",
      title: "Lucky Draw Campaign",
      category: "Campaign Video",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/f189e7253836049.Y3JvcCwxMDgwLDg0NCwwLDYxMg.png",
      link: "https://www.behance.net/gallery/253836049/Lucky-Draw-Campaign",
      span: "lg:col-span-6",
      ratio: "aspect-[3/2]",
    },
    {
      id: "campaign-kickoff",
      title: "Campaign Kick-Off",
      category: "Campaign Video",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/2c6e0b253835717.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png",
      link: "https://www.behance.net/gallery/253835717/Campaign-Kick-Off-Video",
      span: "lg:col-span-6",
      ratio: "aspect-[3/2]",
    },
    {
      id: "gst-success",
      title: "GST Success",
      category: "Marketing Creatives",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/22d3fb253835387.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png",
      link: "https://www.behance.net/gallery/253835387/GST-Success-Campaign",
      span: "lg:col-span-4",
      ratio: "aspect-[4/5]",
    },
    {
      id: "new-theme-launch",
      title: "New Theme Launch",
      category: "Launch Campaign",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/f9012a253835129.Y3JvcCwxMDgwLDg0NCwwLDE5Nw.png",
      link: "https://www.behance.net/gallery/253835129/New-Theme-Launch",
      span: "lg:col-span-4",
      ratio: "aspect-[4/5]",
    },
    {
      id: "campaign-reel",
      title: "Campaign Reel",
      category: "Social Reel",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/e0bdc2253834853.Y3JvcCwxMDgwLDg0NCwwLDcy.png",
      link: "https://www.behance.net/gallery/253834853/Campaign-Reel",
      span: "lg:col-span-4",
      ratio: "aspect-[4/5]",
    },
    {
      id: "performance-marketing",
      title: "Performance Marketing",
      category: "Performance Marketing",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/e3abb5253817961.Y3JvcCwyMTYwLDE2ODksMCwxMDc0.png",
      link: "https://www.behance.net/gallery/253817961/Performance-Marketing-Campaign",
      span: "lg:col-span-8",
      ratio: "aspect-[16/10]",
    },
    {
      id: "experience-center",
      title: "Experience Center",
      category: "Motion Graphics",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/d88b97253754121.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png",
      link: "https://www.behance.net/gallery/253754121/Experience-Center-Motion-Graphics-Campaign",
      span: "lg:col-span-4",
      ratio: "aspect-[4/5]",
    },
    {
      id: "window-wonderful-home",
      title: "Window to a Wonderful Home",
      category: "Brand Film",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/dce629253753713.Y3JvcCwxMDgwLDg0NCwwLDk4OQ.png",
      link: "https://www.behance.net/gallery/253753713/Window-to-a-Wonderful-Home",
      span: "lg:col-span-6",
      ratio: "aspect-[3/2]",
    },
    {
      id: "ai-visual-production",
      title: "AI-Driven Visual Production",
      category: "AI Cinematic Animation",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/48ec29253753557.Y3JvcCw5ODEsNzY4LDE5Niww.png",
      link: "https://www.behance.net/gallery/253753557/AI-Driven-Visual-Production-Cinematic-Animation",
      span: "lg:col-span-6",
      ratio: "aspect-[3/2]",
    },
    {
      id: "internal-communication",
      title: "Internal Communication Film",
      category: "Culture Film",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/e68eb7253752609.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png",
      link: "https://www.behance.net/gallery/253752609/Internal-Communication-Film",
      span: "lg:col-span-4",
      ratio: "aspect-[4/5]",
    },
    {
      id: "bonito-factory-tour",
      title: "Bonito Designs Factory Tour",
      category: "Brand Documentary",
      group: "Creative Production",
      year: "",
      image: "https://mir-s3-cdn-cf.behance.net/projects/max_808/b0f819253752125.Y3JvcCwxMzgwLDEwODAsMjcwLDA.png",
      link: "https://www.behance.net/gallery/253752125/Bonito-Designs-Factory-Tour",
      span: "lg:col-span-8",
      ratio: "aspect-[16/10]",
    },

    // ---- Broadcast Motion Graphics (21) ----
    ...BMG_PROJECTS,
  ],
};

export const SERVICES = {
  overline: "What I Do",
  title: "Services",
  items: [
    { no: "01", name: "Creative Direction", body: "Transforming ideas into compelling visual stories with a clear creative vision." },
    { no: "02", name: "Creative Production", body: "Managing projects from concept and scripting to production and final delivery." },
    { no: "03", name: "Filmmaking", body: "Cinematic brand films, commercials, and digital content with a storytelling-first approach." },
    { no: "04", name: "Motion Graphics", body: "Engaging motion design that simplifies ideas and captures attention." },
    { no: "05", name: "Video Editing", body: "Fast-paced, emotionally engaging edits that keep audiences watching." },
    { no: "06", name: "AI Content Creation", body: "Leveraging AI tools to accelerate ideation, visualization, and high-quality production." },
  ],
};

export const SKILLS = [
  "Creative Direction",
  "Creative Production",
  "Filmmaking",
  "Motion Graphics",
  "Video Editing",
  "AI Content Creation",
  "Brand Storytelling",
];

export const TOOLS = [
  "Adobe After Effects",
  "Adobe Premiere Pro",
  "Adobe Photoshop",
  "Adobe Illustrator",
  "Cinema 4D",
  "Google Veo",
  "Midjourney",
  "Nano Banana",
  "ChatGPT",
  "Kling AI",
  "Runway",
  "ElevenLabs",
];

export const PROCESS = {
  overline: "How It Works",
  title: "The Creative Process",
  steps: [
    { no: "01", name: "Discover", body: "Understanding the brand, the audience, and the story worth telling." },
    { no: "02", name: "Concept", body: "Developing ideas, scripts, and creative direction that set the tone." },
    { no: "03", name: "Produce", body: "Bringing the vision to life through filming, design, and motion." },
    { no: "04", name: "Deliver", body: "Editing, post-production, and polishing every frame to perfection." },
  ],
};

export const AWARDS = [
  { year: "2024", title: "Best Director", org: "Big Eddy Film Festival" },
  { year: "2023", title: "Best Short Film", org: "Tag Film Festival" },
  { year: "2022", title: "Best Director", org: "Flamingo Film Festival" },
];

export const CONTACT = {
  overline: "Contact",
  title: "Let's Create Something Memorable.",
  body:
    "Every great project starts with a conversation. Whether you're building a brand, launching a campaign, producing a film, or exploring a new creative idea, I'd love to hear about it.",
  tag: "Let's turn your vision into work that connects, inspires, and stands out.",
  email: "swarajsawantsvo@gmail.com",
  phone: "+91 93230 51697",
  phoneHref: "+919323051697",
};
